module.exports = __webpack_public_path__ + "img/icon-add-folder.93a4148a.svg";